import { render, staticRenderFns } from "./selectBiTable.vue?vue&type=template&id=fdd79f92&scoped=true"
import script from "./selectBiTable.vue?vue&type=script&lang=js"
export * from "./selectBiTable.vue?vue&type=script&lang=js"
import style0 from "./selectBiTable.vue?vue&type=style&index=0&id=fdd79f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd79f92",
  null
  
)

export default component.exports